module.exports = __webpack_public_path__ + "img/check-circle.3e5528c9.png";